// extracted by mini-css-extract-plugin
export default {"recos":"l4-z","productCardOverride":"m4-z","rowHasBadge":"n4-z"};